/**
 * Os atalhos de periodo do dashboard (spec 053, 3.1). O dia de hoje e o de Sao Paulo; o periodo anterior e o
 * agrupamento quem calcula e o servico (`@mtc/contratos`), a tela so escolhe o intervalo e escreve os rotulos.
 */
import { diasNoPeriodo, MAXIMO_DE_DIAS_DAS_METRICAS, somarDiasAoDia, somarMeses, type PeriodoDasMetricas } from "@mtc/contratos";

export type Atalho = "hoje" | "7-dias" | "mes-atual" | "mes-passado" | "12-meses" | "datas";

export const ATALHOS: { valor: Atalho; rotulo: string }[] = [
  { valor: "hoje", rotulo: "Hoje" },
  { valor: "7-dias", rotulo: "7 dias" },
  { valor: "mes-atual", rotulo: "Mês atual" },
  { valor: "mes-passado", rotulo: "Mês passado" },
  { valor: "12-meses", rotulo: "12 meses" },
  { valor: "datas", rotulo: "Escolher datas" },
];

export const ehAtalho = (v: string | null): v is Atalho => ATALHOS.some((a) => a.valor === v);

/** O intervalo de cada atalho. "12 meses" sao os 11 meses cheios antes deste mais o mes atual ate hoje (o grafico vai por mes). */
export function periodoDoAtalho(a: Exclude<Atalho, "datas">, hoje: string): PeriodoDasMetricas {
  const mes = hoje.slice(0, 7);
  switch (a) {
    case "hoje":
      return { de: hoje, ate: hoje };
    case "7-dias":
      return { de: somarDiasAoDia(hoje, -6), ate: hoje };
    case "mes-atual":
      return { de: `${mes}-01`, ate: hoje };
    case "mes-passado": {
      const anterior = somarMeses(mes, -1);
      return { de: `${anterior}-01`, ate: somarDiasAoDia(`${mes}-01`, -1) };
    }
    case "12-meses":
      return { de: `${somarMeses(mes, -11)}-01`, ate: hoje };
  }
}

/** O que o servico aceita: datas de verdade, em ordem e ate o limite. Fora disso a tela avisa e nao pergunta. */
export function erroDoPeriodo(p: PeriodoDasMetricas): string | null {
  const dia = /^\d{4}-\d{2}-\d{2}$/;
  if (!dia.test(p.de) || !dia.test(p.ate)) return "Escolha as duas datas.";
  if (p.de > p.ate) return "A data inicial vem antes da final.";
  if (diasNoPeriodo(p) > MAXIMO_DE_DIAS_DAS_METRICAS) return `Escolha até ${MAXIMO_DE_DIAS_DAS_METRICAS} dias.`;
  return null;
}

const MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

/** Rotulo do eixo: "05/10" pro dia, "out/26" pro mes. */
export function rotuloDaChave(chave: string): string {
  const [ano, mes, dia] = chave.split("-");
  return dia ? `${dia}/${mes}` : `${MESES[Number(mes) - 1]}/${ano!.slice(2)}`;
}

/** "01/10/2026 a 16/10/2026", ou so o dia quando e um dia. */
export function rotuloDoPeriodo(p: PeriodoDasMetricas): string {
  const f = (d: string) => d.split("-").reverse().join("/");
  return p.de === p.ate ? f(p.de) : `${f(p.de)} a ${f(p.ate)}`;
}
